<form [formGroup]="form" (ngSubmit)="onSubmit1()"
  class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8  bg-white rounded-xl p-6 shadow-md">


  <!-- Machine Type -->
  <div class="col-span-6">
    <mat-label>Machine Type </mat-label>

    <mat-form-field appearance="outline">
      <mat-select formControlName="machineType">
        <mat-option value="" disabled>Select Machine Type</mat-option>
        <mat-option *ngFor="let type of machineCategories" [value]="type.id">{{ type.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="submitted && f['machineType'].errors?.['required']">
        Machine Type is required
      </mat-error>
    </mat-form-field>
  </div>


  <div class="col-span-6">
    <mat-label>Machine</mat-label>

    <mat-form-field appearance="outline">
      <input type="text" matInput formControlName="machineName" [matAutocomplete]="auto"
        placeholder="Select Machine Name" />
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption>
        <mat-option *ngFor="let type of filteredMachine | async" [value]="type.equipment_name">
          {{ type.equipment_name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="submitted && machineControl.hasError('required')">
        Machine is required
      </mat-error>
    </mat-form-field>
  </div>



  <div class="col-span-6">
    <mat-label>User Name </mat-label>

    <mat-form-field appearance="outline">
      <mat-select formControlName="userName">
        <mat-option value="" disabled>Select User Name</mat-option>
        <mat-option *ngFor="let user of staffList" [value]="user?.personnel_id">{{ user?.full_name }}</mat-option>

      </mat-select>
      <mat-error *ngIf="submitted && f['userName'].errors?.['required']">
        User Name is required
      </mat-error>
    </mat-form-field>
  </div>



  <div class="col-span-6">
    <mat-label>Start Date </mat-label>

    <mat-form-field appearance="outline">
      <input matInput [max]="cValue" [matDatepicker]="startPicker" formControlName="startDate" />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="submitted && f['startDate'].errors?.['required']">
        Start Date is required
      </mat-error>
    </mat-form-field>
  </div>



  <div class="col-span-6">
    <mat-label>End Date </mat-label>

    <mat-form-field appearance="outline">
      <input matInput [min]="f['startDate'].value" [matDatepicker]="endPicker"
        formControlName="endDate" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
      <mat-error *ngIf="submitted && f['endDate'].errors?.['required']">
        End Date is required
      </mat-error>
    </mat-form-field>
  </div>

  <!-- End Date (can span full width if needed) -->


  <!-- Remark -->
  <div class="col-span-6">
    <mat-label>Remark </mat-label>

    <mat-form-field appearance="outline" class="w-full md:col-span-2">
      <input matInput formControlName="remark" />
      <mat-error *ngIf="submitted && f['remark'].errors?.['required']">
        Remark is required
      </mat-error>
    </mat-form-field>
  </div>




  <div class="w-full flex justify-end mt-4">
    <button mat-raised-button color="primary" class="w-60" (click)="onSubmit1()">Save</button>
  </div>
</form>



